module.exports = __webpack_public_path__ + "img/values-integrity.3e0c23dc.gif";